import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
};

const controlPanelSlice = createSlice({
  name: "controlPanelStatus",
  initialState,
  reducers: {
    setIsOpen: (state, action) => {
      state.isOpen = action.payload.isOpen;
    },
  },
});

export const { setIsOpen } = controlPanelSlice.actions;

export default controlPanelSlice.reducer;
